import React, { useState } from "react";
import {
    TextField,
    IconButton,
    Box,
    Grid,
    Typography,
    TableCell,
    TableRow,
} from "@material-ui/core";
import { Add as AddIcon, Remove as RemoveIcon } from "@material-ui/icons";

const ChildAgesForm = ({ item, fieldUpdateHandler }) => {
    const addNewChildAge = () => {
        fieldUpdateHandler("child_ages", [
            ...item?.child_ages,
            { code: "", ageFrom: "", ageTo: "", desc: "" },
        ]);
    };

    const handleFieldChange = (index, field, value) => {
        const updated = [...item.child_ages];
        updated[index][field] = value;

        fieldUpdateHandler("child_ages", updated);
    };

    const handleRemove = (index) => {
        const updated = item.child_ages.filter((_, idx) => idx !== index);

        fieldUpdateHandler("child_ages", updated);
    };

    return (
        <TableRow>
            <TableCell>
                <Typography style={{ margin: "0 0 30px" }}>
                    Категории возрастов детей
                </Typography>

                <Grid container spacing={2}>
                    {item?.child_ages?.map((age, index) => (
                        <Grid item xs={12} key={index}>
                            <Box display="flex" alignItems="center">
                                <TextField
                                    label="Code"
                                    value={age.code}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            index,
                                            "code",
                                            e.target.value,
                                        )
                                    }
                                    fullWidth
                                    style={{ width: "100px" }}
                                />
                                <TextField
                                    label="Age From"
                                    type="number"
                                    value={age.ageFrom}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            index,
                                            "ageFrom",
                                            e.target.value,
                                        )
                                    }
                                    fullWidth
                                    style={{ width: "100px" }}
                                />
                                <TextField
                                    label="Age To"
                                    type="number"
                                    value={age.ageTo}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            index,
                                            "ageTo",
                                            e.target.value,
                                        )
                                    }
                                    fullWidth
                                    style={{ width: "100px" }}
                                />
                                <TextField
                                    label="Description"
                                    value={age.desc}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            index,
                                            "desc",
                                            e.target.value,
                                        )
                                    }
                                    fullWidth
                                    style={{ width: "400px" }}
                                />
                                <IconButton
                                    onClick={() => handleRemove(index)}
                                    color="error"
                                    style={{ color: "red" }}
                                >
                                    <RemoveIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </TableCell>
            <TableCell>
                <IconButton
                    onClick={addNewChildAge}
                    color="primary"
                    style={{ color: "green" }}
                >
                    <AddIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ChildAgesForm;
